<div class="flex flex-1 flex-col overflow-hidden">
    <div class="grid-header">
        <div class="flex">
            <!-- left position custom header template -->
            <ng-container
                *ngFor="
                    let gridCustomHeader of gridCustomHeadersTemplate
                        | filterGridCustomHeaderTemplatesPositionPipe: 'left'
                "
            >
                <ng-container
                    *ngTemplateOutlet="gridCustomHeader.templateRef"
                ></ng-container>
            </ng-container>
        </div>

        <div class="flex">
            <!-- beforeGridButtons position custom header template -->
            <ng-container
                *ngFor="
                    let gridCustomHeader of gridCustomHeadersTemplate
                        | filterGridCustomHeaderTemplatesPositionPipe
                            : 'beforeGridButtons'
                "
            >
                <ng-container
                    *ngTemplateOutlet="gridCustomHeader.templateRef"
                ></ng-container>
            </ng-container>

            <!-- search component -->
            <au-grid-search
                *ngIf="hasSearch"
                class="mr-2"
                [searchState]="gridState.search"
                (searchChange)="handleSearchStateChange($event)"
                (search)="handleSearch($event)"
            ></au-grid-search>

            <button
                *ngIf="hasExportButton"
                type="button"
                class="mr-2"
                [matMenuTriggerFor]="menuExport"
                mat-icon-button
            >
                <mat-icon>file_download</mat-icon>
                <span class="cdk-visually-hidden">
                    Export menu to excel and CSV
                </span>
            </button>
            <mat-menu #menuExport="matMenu">
                <button
                    type="button"
                    mat-menu-item
                    (click)="handleExport($event, exportFormat.EXCEL)"
                >
                    <mat-icon>functions</mat-icon>
                    <span>Excel</span>
                </button>
                <button
                    type="button"
                    mat-menu-item
                    (click)="handleExport($event, exportFormat.CSV)"
                >
                    <mat-icon>table_view</mat-icon>
                    <span>CSV</span>
                </button>
            </mat-menu>

            <!-- filter dialog -->
            <button
                *ngIf="hasFilterButton"
                type="button"
                class="mr-2"
                mat-icon-button
                (click)="handleFiltersDialog()"
            >
                <mat-icon
                    aria-hidden="false"
                    [matBadge]="gridState.columnFilters?.length"
                    [matBadgeHidden]="gridState.columnFilters?.length == 0"
                    matBadgeColor="warn"
                >
                    filter_list
                </mat-icon>
                <span class="cdk-visually-hidden">
                    Filter icon showing active filters with a value of
                    {{ gridState.columnFilters?.length }}
                </span>
            </button>

            <!-- columns configurator -->
            <button
                *ngIf="hasColumnsConfigPropertiesButton"
                type="button"
                class="mr-2"
                mat-icon-button
                (click)="handleColumnsConfigPropertiesDialog()"
            >
                <mat-icon
                    aria-hidden="false"
                    [matBadge]="'!'"
                    [matBadgeHidden]="
                        gridState.columnsConfig
                            | isOriginColumnConfig: originColumnsConfig()
                    "
                >
                    table_chart
                </mat-icon>
            </button>

            <!-- right position custom header template -->
            <ng-container
                *ngFor="
                    let gridCustomHeader of gridCustomHeadersTemplate
                        | filterGridCustomHeaderTemplatesPositionPipe: 'right'
                "
            >
                <ng-container
                    *ngTemplateOutlet="gridCustomHeader.templateRef"
                ></ng-container>
            </ng-container>
        </div>
    </div>

    <div class="grid-content overflow-auto">
        <table
            class="w-full flex-1"
            [dataSource]="gridData?.rows"
            [matSortActive]="gridState?.sort.active"
            [matSortDirection]="gridState?.sort.direction"
            [cdkDropListDisabled]="!hasDragAndDrop"
            [cdkDropListData]="gridData?.rows"
            mat-table
            matSort
            cdkDropList
            (cdkDropListDropped)="rowDrop.emit($event)"
        >
            <ng-container *ngFor="let columnConfig of gridState.columnsConfig">
                <ng-container
                    [matColumnDef]="columnConfig.field"
                    [sticky]="columnConfig.sticky"
                >
                    @if (!columnConfig.hidden) {
                        @switch (columnConfig.type) {
                            <!-- STRING -->
                            @case (columnConfigType.STRING) {
                                <th
                                    *matHeaderCellDef
                                    [ngClass]="columnConfig.headerClass"
                                    [disabled]="!columnConfig.sort"
                                    [mat-sort-header]="columnConfig.sort"
                                    mat-header-cell
                                >
                                    {{
                                        columnConfig.field
                                            | gridTranslate: 'column' : id
                                            | async
                                    }}
                                </th>
                                <td
                                    *matCellDef="let row"
                                    [ngClass]="columnConfig.bodyClass"
                                    mat-cell
                                >
                                    <!-- set value by template -->
                                    <div
                                        *ngFor="
                                            let cellValueTemplate of gridCellValuesTemplate
                                        "
                                    >
                                        <div
                                            *ngIf="
                                                (gridCellValuesTemplate
                                                    | hasCellValueWithFieldTemplate
                                                        : columnConfig) &&
                                                cellValueTemplate.field ===
                                                    columnConfig.field
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellValueTemplate.templateRef;
                                                    context: {
                                                        $implicit:
                                                            row
                                                            | getCellValue
                                                                : columnConfig.field,
                                                        columnConfig,
                                                        row,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                        <!-- set value by template for all fields -->
                                        <div
                                            *ngIf="
                                                !(
                                                    gridCellValuesTemplate
                                                    | hasCellValueWithFieldTemplate
                                                        : columnConfig
                                                ) &&
                                                cellValueTemplate.field ===
                                                    undefined
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellValueTemplate.templateRef;
                                                    context: {
                                                        $implicit:
                                                            row
                                                            | getCellValue
                                                                : columnConfig.field,
                                                        columnConfig,
                                                        row,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                    </div>
                                    <!-- set value by columns config transform -->
                                    <div
                                        *ngIf="
                                            !(
                                                gridCellValuesTemplate
                                                | hasCellValueTemplate
                                                    : columnConfig
                                            )
                                        "
                                    >
                                        {{
                                            row
                                                | getCellValue
                                                    : columnConfig.field
                                                | transformDataCell
                                                    : columnConfig.transform
                                        }}
                                    </div>
                                </td>
                            }

                            <!-- BOOLEAN -->
                            @case (columnConfigType.BOOLEAN) {
                                <th
                                    *matHeaderCellDef
                                    [ngClass]="columnConfig.headerClass"
                                    [disabled]="!columnConfig.sort"
                                    [mat-sort-header]="columnConfig.sort"
                                    mat-header-cell
                                >
                                    {{
                                        columnConfig.field
                                            | gridTranslate: 'column' : id
                                            | async
                                    }}
                                </th>
                                <td
                                    *matCellDef="let row"
                                    [ngClass]="columnConfig.bodyClass"
                                    mat-cell
                                >
                                    <!-- set value by template -->
                                    <div
                                        *ngFor="
                                            let cellValueTemplate of gridCellValuesTemplate
                                        "
                                    >
                                        <div
                                            *ngIf="
                                                (gridCellValuesTemplate
                                                    | hasCellValueWithFieldTemplate
                                                        : columnConfig) &&
                                                cellValueTemplate.field ===
                                                    columnConfig.field
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellValueTemplate.templateRef;
                                                    context: {
                                                        $implicit:
                                                            row
                                                            | getCellValue
                                                                : columnConfig.field,
                                                        columnConfig,
                                                        row,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                        <!-- set value by template for all fields -->
                                        <div
                                            *ngIf="
                                                !(
                                                    gridCellValuesTemplate
                                                    | hasCellValueWithFieldTemplate
                                                        : columnConfig
                                                ) &&
                                                cellValueTemplate.field ===
                                                    undefined
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellValueTemplate.templateRef;
                                                    context: {
                                                        $implicit:
                                                            row
                                                            | getCellValue
                                                                : columnConfig.field,
                                                        columnConfig,
                                                        row,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                    </div>
                                    <!-- set value by columns config transform -->
                                    <div
                                        *ngIf="
                                            !(
                                                gridCellValuesTemplate
                                                | hasCellValueTemplate
                                                    : columnConfig
                                            )
                                        "
                                    >
                                        <mat-icon
                                            *ngIf="
                                                row
                                                    | getCellValue
                                                        : columnConfig.field
                                            "
                                        >
                                            done
                                        </mat-icon>
                                    </div>
                                </td>
                            }

                            <!-- NUMBER -->
                            @case (columnConfigType.NUMBER) {
                                <th
                                    *matHeaderCellDef
                                    [ngClass]="columnConfig.headerClass"
                                    [disabled]="!columnConfig.sort"
                                    [mat-sort-header]="columnConfig.sort"
                                    mat-header-cell
                                >
                                    {{
                                        columnConfig.field
                                            | gridTranslate: 'column' : id
                                            | async
                                    }}
                                </th>
                                <td
                                    *matCellDef="let row"
                                    [ngClass]="columnConfig.bodyClass"
                                    mat-cell
                                >
                                    <!-- set value by template -->
                                    <div
                                        *ngFor="
                                            let cellValueTemplate of gridCellValuesTemplate
                                        "
                                    >
                                        <div
                                            *ngIf="
                                                (gridCellValuesTemplate
                                                    | hasCellValueWithFieldTemplate
                                                        : columnConfig) &&
                                                cellValueTemplate.field ===
                                                    columnConfig.field
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellValueTemplate.templateRef;
                                                    context: {
                                                        $implicit:
                                                            row
                                                            | getCellValue
                                                                : columnConfig.field,
                                                        columnConfig,
                                                        row,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                        <!-- set value by template for all fields -->
                                        <div
                                            *ngIf="
                                                !(
                                                    gridCellValuesTemplate
                                                    | hasCellValueWithFieldTemplate
                                                        : columnConfig
                                                ) &&
                                                cellValueTemplate.field ===
                                                    undefined
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellValueTemplate.templateRef;
                                                    context: {
                                                        $implicit:
                                                            row
                                                            | getCellValue
                                                                : columnConfig.field,
                                                        columnConfig,
                                                        row,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                    </div>
                                    <!-- set value by columns config transform -->
                                    <div
                                        *ngIf="
                                            !(
                                                gridCellValuesTemplate
                                                | hasCellValueTemplate
                                                    : columnConfig
                                            )
                                        "
                                    >
                                        {{
                                            row
                                                | getCellValue
                                                    : columnConfig.field
                                                | transformDataCell
                                                    : columnConfig.transform
                                        }}
                                    </div>
                                </td>
                            }

                            <!-- DATE -->
                            @case (columnConfigType.DATE) {
                                <th
                                    *matHeaderCellDef
                                    [ngClass]="columnConfig.headerClass"
                                    [disabled]="!columnConfig.sort"
                                    [mat-sort-header]="columnConfig.sort"
                                    mat-header-cell
                                >
                                    {{
                                        columnConfig.field
                                            | gridTranslate: 'column' : id
                                            | async
                                    }}
                                </th>
                                <td
                                    *matCellDef="let row"
                                    [ngClass]="columnConfig.bodyClass"
                                    mat-cell
                                >
                                    <!-- set value by template -->
                                    <div
                                        *ngFor="
                                            let cellValueTemplate of gridCellValuesTemplate
                                        "
                                    >
                                        <div
                                            *ngIf="
                                                (gridCellValuesTemplate
                                                    | hasCellValueWithFieldTemplate
                                                        : columnConfig) &&
                                                cellValueTemplate.field ===
                                                    columnConfig.field
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellValueTemplate.templateRef;
                                                    context: {
                                                        $implicit:
                                                            row
                                                            | getCellValue
                                                                : columnConfig.field,
                                                        columnConfig,
                                                        row,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                        <!-- set value by template for all fields -->
                                        <div
                                            *ngIf="
                                                !(
                                                    gridCellValuesTemplate
                                                    | hasCellValueWithFieldTemplate
                                                        : columnConfig
                                                ) &&
                                                cellValueTemplate.field ===
                                                    undefined
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellValueTemplate.templateRef;
                                                    context: {
                                                        $implicit:
                                                            row
                                                            | getCellValue
                                                                : columnConfig.field,
                                                        columnConfig,
                                                        row,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                    </div>
                                    <!-- set value by columns config transform -->
                                    <div
                                        *ngIf="
                                            !(
                                                gridCellValuesTemplate
                                                | hasCellValueTemplate
                                                    : columnConfig
                                            )
                                        "
                                    >
                                        {{
                                            row
                                                | getCellValue
                                                    : columnConfig.field
                                                | transformDataCell
                                                    : columnConfig.transform
                                        }}
                                    </div>
                                </td>
                            }

                            <!-- TIMESTAMP -->
                            @case (columnConfigType.TIMESTAMP) {
                                <th
                                    *matHeaderCellDef
                                    [ngClass]="columnConfig.headerClass"
                                    [disabled]="!columnConfig.sort"
                                    [mat-sort-header]="columnConfig.sort"
                                    mat-header-cell
                                >
                                    {{
                                        columnConfig.field
                                            | gridTranslate: 'column' : id
                                            | async
                                    }}
                                </th>
                                <td
                                    *matCellDef="let row"
                                    [ngClass]="columnConfig.bodyClass"
                                    mat-cell
                                >
                                    <!-- set value by template -->
                                    <div
                                        *ngFor="
                                            let cellValueTemplate of gridCellValuesTemplate
                                        "
                                    >
                                        <div
                                            *ngIf="
                                                (gridCellValuesTemplate
                                                    | hasCellValueWithFieldTemplate
                                                        : columnConfig) &&
                                                cellValueTemplate.field ===
                                                    columnConfig.field
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellValueTemplate.templateRef;
                                                    context: {
                                                        $implicit:
                                                            row
                                                            | getCellValue
                                                                : columnConfig.field,
                                                        columnConfig,
                                                        row,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                        <!-- set value by template for all fields -->
                                        <div
                                            *ngIf="
                                                !(
                                                    gridCellValuesTemplate
                                                    | hasCellValueWithFieldTemplate
                                                        : columnConfig
                                                ) &&
                                                cellValueTemplate.field ===
                                                    undefined
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellValueTemplate.templateRef;
                                                    context: {
                                                        $implicit:
                                                            row
                                                            | getCellValue
                                                                : columnConfig.field,
                                                        columnConfig,
                                                        row,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                    </div>
                                    <!-- set value by columns config transform -->
                                    <div
                                        *ngIf="
                                            !(
                                                gridCellValuesTemplate
                                                | hasCellValueTemplate
                                                    : columnConfig
                                            )
                                        "
                                    >
                                        {{
                                            row
                                                | getCellValue
                                                    : columnConfig.field
                                                | transformDataCell
                                                    : columnConfig.transform
                                        }}
                                    </div>
                                </td>
                            }

                            <!-- ENUM -->
                            @case (columnConfigType.ENUM) {
                                <th
                                    *matHeaderCellDef
                                    [ngClass]="columnConfig.headerClass"
                                    [disabled]="!columnConfig.sort"
                                    [mat-sort-header]="columnConfig.sort"
                                    mat-header-cell
                                >
                                    {{
                                        columnConfig.field
                                            | gridTranslate: 'column' : id
                                            | async
                                    }}
                                </th>
                                <td
                                    *matCellDef="let row"
                                    [ngClass]="columnConfig.bodyClass"
                                    mat-cell
                                >
                                    <!-- set value by template -->
                                    <div
                                        *ngFor="
                                            let cellValueTemplate of gridCellValuesTemplate
                                        "
                                    >
                                        <div
                                            *ngIf="
                                                (gridCellValuesTemplate
                                                    | hasCellValueWithFieldTemplate
                                                        : columnConfig) &&
                                                cellValueTemplate.field ===
                                                    columnConfig.field
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellValueTemplate.templateRef;
                                                    context: {
                                                        $implicit:
                                                            row
                                                            | getCellValue
                                                                : columnConfig.field,
                                                        columnConfig,
                                                        row,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                        <!-- set value by template for all fields -->
                                        <div
                                            *ngIf="
                                                !(
                                                    gridCellValuesTemplate
                                                    | hasCellValueWithFieldTemplate
                                                        : columnConfig
                                                ) &&
                                                cellValueTemplate.field ===
                                                    undefined
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellValueTemplate.templateRef;
                                                    context: {
                                                        $implicit:
                                                            row
                                                            | getCellValue
                                                                : columnConfig.field,
                                                        columnConfig,
                                                        row,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                    </div>
                                    <!-- set value by columns config transform -->
                                    <div
                                        *ngIf="
                                            !(
                                                gridCellValuesTemplate
                                                | hasCellValueTemplate
                                                    : columnConfig
                                            )
                                        "
                                    >
                                        {{
                                            row
                                                | getCellValue
                                                    : columnConfig.field
                                                | transformDataCell
                                                    : columnConfig.transform
                                        }}
                                    </div>
                                </td>
                            }

                            <!-- ARRAY -->
                            @case (columnConfigType.ARRAY) {
                                <th
                                    *matHeaderCellDef
                                    [ngClass]="columnConfig.headerClass"
                                    [disabled]="!columnConfig.sort"
                                    [mat-sort-header]="columnConfig.sort"
                                    mat-header-cell
                                >
                                    {{
                                        columnConfig.field
                                            | gridTranslate: 'column' : id
                                            | async
                                    }}
                                </th>
                                <td
                                    *matCellDef="let row"
                                    [ngClass]="columnConfig.bodyClass"
                                    mat-cell
                                >
                                    <!-- set value by template -->
                                    <div
                                        *ngFor="
                                            let cellValueTemplate of gridCellValuesTemplate
                                        "
                                    >
                                        <div
                                            *ngIf="
                                                (gridCellValuesTemplate
                                                    | hasCellValueWithFieldTemplate
                                                        : columnConfig) &&
                                                cellValueTemplate.field ===
                                                    columnConfig.field
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellValueTemplate.templateRef;
                                                    context: {
                                                        $implicit:
                                                            row
                                                            | getCellValue
                                                                : columnConfig.field,
                                                        columnConfig,
                                                        row,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                        <!-- set value by template for all fields -->
                                        <div
                                            *ngIf="
                                                !(
                                                    gridCellValuesTemplate
                                                    | hasCellValueWithFieldTemplate
                                                        : columnConfig
                                                ) &&
                                                cellValueTemplate.field ===
                                                    undefined
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellValueTemplate.templateRef;
                                                    context: {
                                                        $implicit:
                                                            row
                                                            | getCellValue
                                                                : columnConfig.field,
                                                        columnConfig,
                                                        row,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                    </div>
                                    <!-- set value by columns config transform -->
                                    <div
                                        *ngIf="
                                            !(
                                                gridCellValuesTemplate
                                                | hasCellValueTemplate
                                                    : columnConfig
                                            )
                                        "
                                    >
                                        {{
                                            row
                                                | getCellValue
                                                    : columnConfig.field
                                                | transformDataCell
                                                    : columnConfig.transform
                                                | join
                                        }}
                                    </div>
                                </td>
                            }

                            <!-- JSONB -->
                            @case (columnConfigType.JSONB) {
                                <th
                                    *matHeaderCellDef
                                    [ngClass]="columnConfig.headerClass"
                                    [disabled]="!columnConfig.sort"
                                    [mat-sort-header]="columnConfig.sort"
                                    mat-header-cell
                                >
                                    {{
                                        columnConfig.field
                                            | gridTranslate: 'column' : id
                                            | async
                                    }}
                                </th>
                                <td
                                    *matCellDef="let row"
                                    [ngClass]="columnConfig.bodyClass"
                                    mat-cell
                                >
                                    <!-- set value by template -->
                                    <div
                                        *ngFor="
                                            let cellValueTemplate of gridCellValuesTemplate
                                        "
                                    >
                                        <div
                                            *ngIf="
                                                (gridCellValuesTemplate
                                                    | hasCellValueWithFieldTemplate
                                                        : columnConfig) &&
                                                cellValueTemplate.field ===
                                                    columnConfig.field
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellValueTemplate.templateRef;
                                                    context: {
                                                        $implicit:
                                                            row
                                                            | getCellValue
                                                                : columnConfig.field,
                                                        columnConfig,
                                                        row,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                        <!-- set value by template for all fields -->
                                        <div
                                            *ngIf="
                                                !(
                                                    gridCellValuesTemplate
                                                    | hasCellValueWithFieldTemplate
                                                        : columnConfig
                                                ) &&
                                                cellValueTemplate.field ===
                                                    undefined
                                            "
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    cellValueTemplate.templateRef;
                                                    context: {
                                                        $implicit:
                                                            row
                                                            | getCellValue
                                                                : columnConfig.field,
                                                        columnConfig,
                                                        row,
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                    </div>
                                    <!-- set value by columns config transform -->
                                    <div
                                        *ngIf="
                                            !(
                                                gridCellValuesTemplate
                                                | hasCellValueTemplate
                                                    : columnConfig
                                            )
                                        "
                                    >
                                        {{
                                            row
                                                | getCellValue
                                                    : columnConfig.field
                                                | transformDataCell
                                                    : columnConfig.transform
                                        }}
                                    </div>
                                </td>
                            }

                            <!-- TRANSLATIONS_MENU -->
                            @case (columnConfigType.TRANSLATIONS_MENU) {
                                <th
                                    *matHeaderCellDef
                                    [ngClass]="columnConfig.headerClass"
                                    [disabled]="!columnConfig.sort"
                                    [mat-sort-header]="columnConfig.sort"
                                    mat-header-cell
                                >
                                    {{
                                        columnConfig.field
                                            | gridTranslate: 'column' : id
                                            | async
                                    }}
                                </th>
                                <td
                                    *matCellDef="let row"
                                    [ngClass]="columnConfig.bodyClass"
                                    mat-cell
                                >
                                    <div class="flex justify-center">
                                        <button
                                            [matMenuTriggerFor]="menu"
                                            [color]="
                                                columnConfig.translationIconColor
                                                    | getTranslationIconColor
                                                        : row
                                            "
                                            mat-icon-button
                                        >
                                            <mat-icon
                                                svgIcon="mat_solid:translate"
                                            ></mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <ng-container
                                                *ngFor="
                                                    let action of columnConfig.actions
                                                        | getActions: row
                                                "
                                            >
                                                <button
                                                    type="button"
                                                    mat-menu-item
                                                    (click)="
                                                        handleClickAction(
                                                            action,
                                                            row,
                                                            $event
                                                        )
                                                    "
                                                >
                                                    <au-flag-icon
                                                        [flagCode]="
                                                            action.meta.lang
                                                                .image
                                                        "
                                                        fontSize="16px"
                                                    >
                                                        {{
                                                            (action.translation
                                                                ? action.translation
                                                                : action.id
                                                            )
                                                                | gridTranslate
                                                                    : 'action'
                                                                    : id
                                                                | async
                                                        }}
                                                    </au-flag-icon>
                                                </button>
                                            </ng-container>
                                        </mat-menu>
                                    </div>
                                </td>
                            }

                            <!-- ACTIONS -->
                            @case (columnConfigType.ACTIONS) {
                                <th
                                    *matHeaderCellDef
                                    [ngClass]="
                                        columnConfig.headerClass
                                            ? columnConfig.headerClass
                                            : 'w-20 text-center'
                                    "
                                    mat-header-cell
                                >
                                    {{
                                        columnConfig.field
                                            | gridTranslate: 'column' : id
                                            | async
                                    }}
                                </th>
                                <td
                                    *matCellDef="let row"
                                    [ngClass]="
                                        columnConfig.bodyClass
                                            ? columnConfig.bodyClass
                                            : 'w-20 text-center'
                                    "
                                    mat-cell
                                >
                                    <!-- print action menu if has more than one action -->
                                    <ng-container
                                        *ngIf="
                                            (
                                                columnConfig.actions
                                                | getActions: row
                                            ).length > 1
                                        "
                                    >
                                        <button
                                            type="button"
                                            [matMenuTriggerFor]="menu"
                                            mat-icon-button
                                        >
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <ng-container
                                                *ngFor="
                                                    let action of columnConfig.actions
                                                        | getActions: row
                                                "
                                            >
                                                <button
                                                    type="button"
                                                    [disabled]="
                                                        action.spinner
                                                            | getGridSpinnerFlag
                                                            | async
                                                    "
                                                    mat-menu-item
                                                    (click)="
                                                        handleClickAction(
                                                            action,
                                                            row,
                                                            $event
                                                        )
                                                    "
                                                >
                                                    <mat-icon
                                                        *ngIf="
                                                            !(
                                                                action.spinner
                                                                | getGridSpinnerFlag
                                                                | async
                                                            )
                                                        "
                                                        aria-hidden="false"
                                                        [svgIcon]="
                                                            action.svgIcon
                                                        "
                                                        [fontSet]="
                                                            action.iconFontSet
                                                        "
                                                        [matBadgeHidden]="
                                                            action.badge?.hidden
                                                        "
                                                        [matBadgeColor]="
                                                            action.badge?.color
                                                        "
                                                        [matBadge]="
                                                            action.badge?.label
                                                        "
                                                    >
                                                        {{ action.icon }}
                                                    </mat-icon>
                                                    <mat-icon
                                                        *ngIf="
                                                            action.spinner
                                                                | getGridSpinnerFlag
                                                                | async
                                                        "
                                                    >
                                                        <mat-spinner
                                                            diameter="20"
                                                        ></mat-spinner>
                                                    </mat-icon>
                                                    <span>
                                                        {{
                                                            (action.translation
                                                                ? action.translation
                                                                : action.id
                                                            )
                                                                | gridTranslate
                                                                    : 'action'
                                                                    : id
                                                                | async
                                                        }}
                                                    </span>
                                                </button>
                                            </ng-container>
                                        </mat-menu>
                                    </ng-container>
                                    <!-- if only have one action, print action without menu -->
                                    <ng-container
                                        *ngIf="
                                            (
                                                columnConfig.actions
                                                | getActions: row
                                            ).length === 1
                                        "
                                    >
                                        <ng-container
                                            *ngFor="
                                                let action of columnConfig.actions
                                                    | getActions: row
                                            "
                                        >
                                            <button
                                                type="button"
                                                [disabled]="
                                                    action.spinner
                                                        | getGridSpinnerFlag
                                                        | async
                                                "
                                                mat-icon-button
                                                (click)="
                                                    handleClickAction(
                                                        action,
                                                        row,
                                                        $event
                                                    )
                                                "
                                            >
                                                <mat-icon
                                                    *ngIf="
                                                        !(
                                                            action.spinner
                                                            | getGridSpinnerFlag
                                                            | async
                                                        )
                                                    "
                                                    aria-hidden="false"
                                                    [svgIcon]="action.svgIcon"
                                                    [fontSet]="
                                                        action.iconFontSet
                                                    "
                                                    [matBadgeHidden]="
                                                        action.badge?.hidden
                                                    "
                                                    [matBadgeColor]="
                                                        action.badge?.color
                                                    "
                                                    [matBadge]="
                                                        action.badge?.label
                                                    "
                                                >
                                                    {{ action.icon }}
                                                </mat-icon>
                                                <mat-icon
                                                    *ngIf="
                                                        action.spinner
                                                            | getGridSpinnerFlag
                                                            | async
                                                    "
                                                >
                                                    <mat-spinner
                                                        diameter="20"
                                                    ></mat-spinner>
                                                </mat-icon>
                                            </button>
                                        </ng-container>
                                    </ng-container>
                                </td>
                            }

                            <!-- CHECKBOX -->
                            @case (columnConfigType.CHECKBOX) {
                                <th
                                    *matHeaderCellDef
                                    [ngClass]="
                                        columnConfig.headerClass
                                            ? columnConfig.headerClass
                                            : 'w-20 text-center'
                                    "
                                    mat-header-cell
                                >
                                    <mat-checkbox
                                        [checked]="
                                            selectedCheckboxRowModel.hasValue() &&
                                            isAllSelected()
                                        "
                                        [indeterminate]="
                                            isSomeSelected() && !isAllSelected()
                                        "
                                        [aria-label]="checkboxLabel()"
                                        (change)="
                                            $event ? masterToggle() : null
                                        "
                                    ></mat-checkbox>
                                </th>
                                <td
                                    *matCellDef="let row"
                                    [ngClass]="
                                        columnConfig.bodyClass
                                            ? columnConfig.bodyClass
                                            : 'w-20 text-center'
                                    "
                                    mat-cell
                                >
                                    <mat-checkbox
                                        [checked]="
                                            selectedCheckboxRowModel.isSelected(
                                                row
                                            )
                                        "
                                        [aria-label]="checkboxLabel(row)"
                                        (click)="$event.stopPropagation()"
                                        (change)="
                                            $event
                                                ? selectedCheckboxRowModel.toggle(
                                                      row
                                                  )
                                                : null
                                        "
                                    ></mat-checkbox>
                                </td>
                            }

                            <!-- DRAG AND DROP -->
                            @case (columnConfigType.DRAG_AND_DROP) {
                                <th
                                    *matHeaderCellDef
                                    [ngClass]="
                                        columnConfig.headerClass
                                            ? columnConfig.headerClass
                                            : 'w-20 text-center'
                                    "
                                    mat-header-cell
                                >
                                    {{
                                        columnConfig.field
                                            | gridTranslate: 'column' : id
                                            | async
                                    }}
                                </th>
                                <td
                                    *matCellDef="let row"
                                    [ngClass]="
                                        columnConfig.bodyClass
                                            ? columnConfig.bodyClass
                                            : 'w-20 text-center'
                                    "
                                    mat-cell
                                >
                                    <mat-icon
                                        class="cursor-move"
                                        cdkDragHandle
                                    >
                                        drag_indicator
                                    </mat-icon>
                                </td>
                            }
                        }
                    }
                </ng-container>
            </ng-container>

            <tr
                *matHeaderRowDef="displayedColumns; sticky: true"
                mat-header-row
            ></tr>
            <tr
                *matRowDef="let row; columns: displayedColumns"
                [cdkDragData]="row"
                mat-row
                cdkDrag
            ></tr>

            <tr
                *matNoDataRow
                class="mat-row"
            >
                <td
                    class="mat-cell"
                    [attr.colspan]="displayedColumns?.length"
                >
                    <p class="p-2 text-base">
                        {{
                            'noData' | gridTranslate: 'message' : gridId | async
                        }}
                    </p>
                </td>
            </tr>
        </table>
    </div>

    <div class="grid-footer">
        @if (hasPagination()) {
            <mat-paginator
                aria-label="Select page of periodic elements"
                class="rounded-b-md"
                [length]="gridData?.count"
                [pageIndex]="gridState?.page?.pageIndex"
                [pageSize]="gridState?.page?.pageSize"
                [pageSizeOptions]="pageSizeOptions()"
                showFirstLastButtons
                (page)="handlePageStateChange($event)"
            ></mat-paginator>
        } @else {
            <div class="h-3"></div>
        }
    </div>
</div>
